import React, { memo } from "react";

import { ImageElement } from "@kontent-ai/gatsby-components";
import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";

interface KontentAssetsImageProps {
  aspectRatio?: number | null;
  data?: Queries.kontent_item_asset_element;
  height?: number;
  width?: number;
  fit?: "crop" | "clip" | "scale" | null;
  className?: string;
}

const KontentAssetsImage: React.FC<KontentAssetsImageProps> = ({
  aspectRatio = null,
  data = undefined,
  height = 0,
  width = 0,
  fit = null,
  className = undefined,
}) => {
  if (!data || !data.url) {
    return null;
  }

  const ratio = aspectRatio || data.height! / data.width!;

  let generatedHeight = null;
  let generatedWidth = null;

  if (!height && width && !aspectRatio) {
    generatedHeight = (width * data.height!) / data.width!;
  }

  if (height && !width && !aspectRatio) {
    generatedWidth = (height * data.width!) / data.height!;
  }

  return (
    <ImageElement
      aspectRatio={ratio}
      image={data as ImageItem}
      alt={data.description || ""}
      height={height || generatedHeight || undefined}
      width={width || generatedWidth || undefined}
      layout="constrained"
      className={className}
      options={{
        fit: fit || "crop",
        lossless: true,
      }}
    />
  );
};

export default memo(KontentAssetsImage);
